import { render } from "./CadastroView.vue?vue&type=template&id=0dab2a1c&scoped=true"
import script from "./CadastroView.vue?vue&type=script&lang=js"
export * from "./CadastroView.vue?vue&type=script&lang=js"

import "./CadastroView.vue?vue&type=style&index=0&id=0dab2a1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dab2a1c"]])

export default __exports__